import { useEffect, useState } from "react";

export const LoadingScreen = ({ label = "CLIP-EX", testid = "loading-screen" }) => {
  const [p, setP] = useState(8);
  useEffect(() => {
    const i = setInterval(() => setP((v) => (v >= 92 ? v : v + Math.max(1, (92 - v) / 9))), 180);
    return () => clearInterval(i);
  }, []);
  return (
    <div className="fixed inset-0 z-[70] grid place-items-center bg-[#04050a]" data-testid={testid}>
      <div className="flex flex-col items-center gap-8">
        <div className="cx-aura cx-aura-lg w-40 h-32 grid place-items-center">
          <img src="/logo-x.png" alt="CLIP-EX" className="relative w-full h-full object-contain cx-float" />
        </div>
        <div className="w-64">
          <div className="h-1.5 rounded-full bg-white/5 overflow-hidden">
            <div className="h-full rounded-full bg-gradient-to-r from-[#3ad7ff] via-[#2f7bff] to-[#a746ff] transition-[width] duration-200 shadow-[0_0_14px_rgba(110,90,255,0.9)]" style={{ width: `${p}%` }} data-testid="loading-bar" />
          </div>
          <div className="mt-3 text-center font-mono text-[11px] tracking-[0.3em] uppercase text-slate-400">{label}</div>
        </div>
      </div>
    </div>
  );
};

export const InlineLoader = ({ label }) => (
  <div className="flex flex-col items-center gap-4" data-testid="inline-loader">
    <div className="cx-aura w-20 h-16 grid place-items-center"><img src="/logo-x.png" alt="" className="relative w-full h-full object-contain cx-float" /></div>
    <div className="w-36 h-1 rounded-full bg-white/5 overflow-hidden"><div className="h-full w-1/3 bg-gradient-to-r from-[#2f7bff] to-[#a746ff] cx-indeterminate" /></div>
    {label && <div className="font-mono text-xs text-slate-400">{label}</div>}
  </div>
);
